import axios from "axios";
import { useSelector } from "react-redux";
import { useRef, useCallback } from "react";

import { generateDynamicSignature } from "../utils/generateDynamicSignature";
import BASE_URL from "../constants/baseURL";

export function useDynamicSignatureAxios() {
  const { authToken } = useSelector((state) => state.memberDetails);
  const token = sessionStorage.getItem("authToken");
  const axiosInstance = useRef(
    axios.create({
      baseURL: BASE_URL.adn_api.url + BASE_URL.adn_api.version,
      timeout: 15000,
      headers: {
        Authorization: authToken || token,
        "content-type": "application/json",
      },
    })
  );

  return useCallback(
    async ({
      url,
      method = "GET",
      data = null,
      params = null,
      headers = {},
    }) => {
      try {
        const { signature, timestamp, nonce } = await generateDynamicSignature(
          data
        );

        const response = await axiosInstance.current({
          url,
          method,
          data,
          params,
          headers: {
            ...headers,
            "x-signature": signature,
            "x-timestamp": timestamp,
            "x-nonce": nonce,
          },
        });

        return response.data;
      } catch (error) {
        throw error;
      }
    },
    []
  );
}
